import { useTranslation } from "react-i18next";

import { useState, useEffect, useRef } from "react";

import y from '../../img/About/years.png'

import Fade from 'react-reveal/Fade'

function Years () {

    const { t } = useTranslation();

    const timelineData = [
        {
            year: 2019,
            title: "about.18",
            text: "about.19",
        },
        {
            year: 2020,
            title: "about.20",
            text: "about.21",
        },
        {
            year: 2021,
            title: "about.22",
            text: "about.23",
        },
        {
            year: 2022,
            title: "about.24",
            text: "about.25",
        },
        {
            year: 2023,
            title: "about.26",
            text: "about.27",
        },
        {
            year: 2024,
            title: "about.28",
            text: "about.29",
        },
        {
            year: 2025,
            title: "about.30",
            text: "about.31",
        },
    ];

    const [selectedYear, setSelectedYear] = useState(2019);
    const [autoPlay, setAutoPlay] = useState(true);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (autoPlay) {
        intervalRef.current = setInterval(() => {
            setSelectedYear((prevYear) => {
            const currentIndex = timelineData.findIndex((item) => item.year === prevYear);
            const nextIndex = (currentIndex + 1) % timelineData.length;
            return timelineData[nextIndex].year;
            });
        }, 3000);
        }

        return () => clearInterval(intervalRef.current);
    }, [autoPlay]);

    const handleYearClick = (year) => {
        setSelectedYear(year);
        setAutoPlay(false); // остановка цикла при клике
        clearInterval(intervalRef.current);
    };

    const current = timelineData.find((item) => item.year === selectedYear);
      
    return(
        <div className="overflow-hidden relative mt-[100px] xl:mt-[140px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row justify-between">
                <div>
                    <p className="manrope text-[24px] xl:text-[48px] font-[500] xl:max-w-[570px] leading-[1.2] text-[#000000]">{t('about.17')}</p>
                    <div className="flex flex-wrap justify-center xl:justify-start gap-y-[10px] mt-[40px] xl:mt-[60px] xl:border-b xl:max-w-[703px] xl:pb-[12px] border-[#CBCBCB]">
                        {timelineData.map((item) => (
                            <button
                                key={item.year}
                                onClick={() => handleYearClick(item.year)}
                                className={`px-6 py-1 rounded-full text-[16px] xl:text-[20px] manrope font-[500] transition-all duration-200 ${selectedYear === item.year ? "bg-black text-white": "text-[#131313] hover:text-black"}`}
                            >
                                {item.year}
                            </button>
                        ))}
                    </div>
                    <Fade key={current.year}>
                        <h2 className="mt-[40px] xl:mt-[60px] manrope text-[16px] xl:text-[20px] leading-[1.2]">{t(current.title)}</h2>
                        <p className="xl:max-w-[703px] mt-[20px] roboto text-[12px] xl:text-[14px] font-[300] text-[#000000B2]">{t(current.text)}</p>
                    </Fade>
                </div>
                <Fade right><img src={y} alt="" className="mt-[40px] xl:mt-0"/></Fade>
            </div>
        </div>
    );
}

export default Years;